import React from "react";
import clsx from "clsx";
import DataTable from "../../DataTable/DataTable";
import DevicesSelect from "../../Selects/DevicesSelect";

class RoomBuilderLocks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    //console.log("RoomBuilderLocks", this.props);

    var tabClasses = clsx({
      active: this.props.active_tab == "locks",
      "tab-pane": true,
    });

    return (
      <div className={`${tabClasses} root`} id="locks">
        <div className="row">
          <div className="col-md-3">
            <label>{`${I18n.t("lock_management")}`}</label>{" "}
            <span
              className="ss-help help"
              title={I18n.t("lock_management_helper_text")}
            ></span>
            <select
              name="lock_management"
              className="form-control"
              onChange={this.props.onChangeRoomField}
              value={this.props.room.lock_management}
            >
              <option value="none">{I18n.t("none")}</option>
              <option value="manual_key_code">
                {I18n.t("manual_key_code")}
              </option>
              {this.props.remotelock_refresh_token ? (
                <option value="remotelock">{I18n.t("remotelock")}</option>
              ) : null}
            </select>
          </div>
          {this.renderLockForm()}
        </div>
        {this.renderRoomLocksDataTable()}
      </div>
    );
  }

  renderLockForm() {
    if (this.props.room.lock_management === "manual_key_code") {
      return (
        <div className="col-md-3">
          <label>{`${I18n.t("pin_code")}`}</label>{" "}
          <span
            className="ss-help help"
            title={I18n.t("pin_code_helper_text")}
          ></span>
          <input
            type="text"
            name="room[pin_code]"
            className="form-control"
            defaultValue={this.props.room.pin_code}
            data-model="Room"
            data-column="pin_code"
            onChange={this.props.onPinCodeChange}
          />
        </div>
      );
    } else if (
      this.props.room.lock_management === "remotelock" &&
      this.props.remotelock_refresh_token
    ) {
      return (
        <div className="col-md-3">
          <label>{`${I18n.t("devices")}`}</label>{" "}
          <span
            className="ss-help help"
            title={I18n.t("remotelock_devices_helper_text")}
          ></span>
          <DevicesSelect
            devices={this.props.room.devices}
            onChange={this.props.onSelectDevices}
          />
        </div>
      );
    }
  }

  renderRoomLocksDataTable() {
    if (
      this.props.room.lock_management === "remotelock" &&
      this.props.room_locks_endpoint
    ) {
      return (
        <div className="row">
          <div className="col-md-12">
            <hr style={{ marginTop: "2rem" }} />
            <DataTable
              endpoint={this.props.room_locks_endpoint}
              no_data_text={I18n.t("no_lock_history")}
              currency_unit={I18n.t("number.currency.format.unit")}
              delimiter={I18n.t("number.currency.format.delimiter")}
              separator={I18n.t("number.currency.format.separator")}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              model_name={"RoomLock"}
            />
          </div>
        </div>
      );
    }
  }
}

export default RoomBuilderLocks;
